<flex-row class="time-picker">
  <div class="hours" [class.highlighted]="hoursHighlighted" (click)="hoursHighlighted = true" (clickOutside)="hoursHighlighted = false">
    {{ currentTime.hours | number: '2.0-0' }}
  </div>
  <div class="colon">:</div>
  <div class="minutes" [class.highlighted]="minutesHighlighted" (click)="minutesHighlighted = true" (clickOutside)="minutesHighlighted = false">
    {{ currentTime.minutes | number: '2.0-0' }}
  </div>
</flex-row>
